const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'drawer',
    viewClass: require('./view'),
});
